import axios from "axios";
async function logout() {
    const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/logout`
    );
    return response;
}
export default logout;